// extracted by mini-css-extract-plugin
module.exports = {"links":"BotHelpfulLinks_links__tBAgy","adminLinks":"BotHelpfulLinks_adminLinks__QlWXq"};